import { Component, isDevMode, OnDestroy } from '@angular/core';
import { App, NavController, NavParams } from 'ionic-angular';
import { PhcApp } from '../../classes/phc-app/phc-app';
import { WpProvider } from '../../providers/wp/wp';
import { KioskServiceProvider } from '../../providers/kiosk-service/kiosk-service';
import { Subscription } from 'rxjs';
import { TabUpdateProvider } from '../../providers/tab-update/tab-update.service';

import { find } from 'lodash';

/**
 * Generated class for the PlanADayPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-plan-a-day',
  templateUrl: 'plan-a-day.html',
})
export class PlanADayPage implements OnDestroy {

  module: any;
  phcApp: PhcApp;
  // moduleSub: Subscription;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams, wp: WpProvider,
    private app: App,
    private kioskService: KioskServiceProvider,
    private planaday: TabUpdateProvider
  ) {
    this.module = this.navParams.get('module');
    this.phcApp = wp.app;

    this.planaday.moduleUpdates.subscribe(newModule => {
      setTimeout(() => {
        this.module = newModule;
      });
    });
  }

  ngOnDestroy() {
    // this.moduleSub.unsubscribe();
  }

  ionViewWillEnter() {
    this.module = this.navParams.get('module');
  }

  activityInterval;

  ionViewDidLoad() {
    this.activityInterval = setInterval(() => {
      this.kioskService.appActivity.next(true);
    }, 1000);
  }

  ionViewDidLeave() {
    clearInterval(this.activityInterval);
  }
}



// WEBPACK FOOTER //
// ./src/pages/plan-a-day/plan-a-day.ts